(function () {
  var root = document.documentElement;
  if (window.Shopify && Shopify.designMode) {
    root.classList.add("age-ok");
  }
  if (document.cookie.indexOf("v1_age=1") !== -1) {
    root.classList.add("age-ok");
  }

  var gate = document.querySelector("[data-age-gate]");
  var enter = document.querySelector("[data-age-enter]");
  var leave = document.querySelector("[data-age-leave]");
  var denied = document.querySelector("[data-age-denied]");
  var prompt = document.querySelector("[data-age-prompt]");

  if (enter) {
    enter.addEventListener("click", function () {
      document.cookie = "v1_age=1; path=/; max-age=2592000; SameSite=Lax";
      root.classList.add("age-ok");
      if (gate) gate.hidden = true;
    });
  }

  if (leave) {
    leave.addEventListener("click", function () {
      if (prompt) prompt.hidden = true;
      if (denied) denied.hidden = false;
    });
  }

  function showView(gallery, thumb) {
    var main = gallery.querySelector(".main-photo");
    if (!main || !thumb) return;
    var full = thumb.getAttribute("data-full");
    if (!full) return;
    main.removeAttribute("srcset");
    main.removeAttribute("sizes");
    main.src = full;
    var alt = thumb.getAttribute("data-alt");
    if (alt) main.alt = alt;
    gallery.querySelectorAll("[data-thumb]").forEach(function (item) {
      if (item === thumb) item.setAttribute("aria-current", "true");
      else item.removeAttribute("aria-current");
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-thumb]");
    if (!thumb) return;
    var gallery = thumb.closest("[data-gallery]");
    if (!gallery) return;
    showView(gallery, thumb);
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-variant]");
    if (!select) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var price = document.querySelector("[data-price]");
    var add = document.querySelector("[data-add]");
    if (price && option.getAttribute("data-price")) {
      price.textContent = option.getAttribute("data-price");
    }
    if (add) {
      var inStock = option.getAttribute("data-available") === "true";
      add.disabled = !inStock;
      add.textContent = inStock ? "Add to cart" : "Sold out";
    }
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var imageId = option.getAttribute("data-image-id");
    var thumb = imageId ? gallery.querySelector('[data-thumb][data-id="' + imageId + '"]') : null;
    if (thumb) {
      showView(gallery, thumb);
      return;
    }
    var full = option.getAttribute("data-full");
    var main = gallery.querySelector(".main-photo");
    if (!full || !main) return;
    main.removeAttribute("srcset");
    main.removeAttribute("sizes");
    main.src = full;
  });
})();
